// Download images function
export const HandleDownloadBtnClick = (_Canvaces, canvas) => {
  _Canvaces.map(async (canvasData) => {
    canvas.setBackgroundImage(null)
    const setDataURL = async () => {
      const dataURL = await canvas.toDataURL({
        width: canvas.width,
        height: canvas.height,
        left: 0,
        top: 0,
        format: "png",
      })
      const link = document.createElement("a")
      link.download = "1.png"
      link.href = dataURL
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      return null
    }
    var json = await JSON.stringify(canvasData)
    await canvas.loadFromJSON(json, async () => {
      await setDataURL()
    })
    return null
  })
}

// Image preview function
